module.exports = __webpack_public_path__ + "assets/img/company_img.51da2305.png";